export const START_DISTANCE = 50
export const RELOAD_DISTANCE = 100

export const TOP_ZONE_HEIGHT = 50
